import { render, staticRenderFns } from "./notificationTemplate.vue?vue&type=template&id=5bf2c844&scoped=true&"
import script from "./notificationTemplate.vue?vue&type=script&lang=js&"
export * from "./notificationTemplate.vue?vue&type=script&lang=js&"
import style0 from "./notificationTemplate.css?vue&type=style&index=0&id=5bf2c844&scoped=true&lang=css&"
import style1 from "./notificationTemplate720.css?vue&type=style&index=1&id=5bf2c844&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf2c844",
  null
  
)

export default component.exports